import React from "react";
import CardItem from "./CardItem";
import "./Cards.css";

function Cardsgallery() {
  return (
    <div className="cards">
      <h1>Cuttape Photo Gallery</h1>
      <h2>Visit our gallery</h2>
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <CardItem
              src="images/img-21.jpg"
              text="Enter gallery for more photos -->"
              label="Cuttape gallery app"
              path="https://cuttapegallery.vercel.app"
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cardsgallery;
